import { default as gql } from 'graphql-tag';

export const notificationsQuery = gql`
query notifications {
  notifications {
    id
    message
    messageId
    url
    createdAt
  }
}
`;
export const markNotified = gql`
  mutation markNotified($id: Int!) {
    markNotified(id: $id) {
      id
    }
  }
`;
